import type { EChartsOption } from 'echarts';
import { useMemo } from 'react';

import { PALETTE } from 'entities/analytics/lib';
import { useLanguages } from 'entities/analytics/model';
import { AnalyticsCard } from 'entities/analytics/ui/analytics-card';
import { EChart } from 'entities/analytics/ui/echart';

export const LanguagesCard = () => {
  const { data, isLoading, isFetching } = useLanguages();
  const series = useMemo(() => data?.data.series ?? [], [data]);

  const option = useMemo<EChartsOption>(
    () => ({
      grid: { left: 8, right: 28, top: 8, bottom: 8, containLabel: true },
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      xAxis: {
        type: 'value',
        axisLine: { lineStyle: { color: '#dfe5e3' } },
        splitLine: { lineStyle: { color: PALETTE.grid } },
        axisLabel: { color: PALETTE.axis },
      },
      yAxis: {
        type: 'category',
        inverse: true,
        data: series.map((p) => p.language),
        axisTick: { show: false },
        axisLine: { lineStyle: { color: '#dfe5e3' } },
        axisLabel: { color: '#40514d', fontSize: 12 },
      },
      series: [
        {
          type: 'bar',
          data: series.map((p) => p.count),
          barWidth: 15,
          itemStyle: { color: PALETTE.primaryDark, borderRadius: [0, 4, 4, 0] },
          // CallbackDataParams.value is a broad union; cast to number for bar label
          label: {
            show: true,
            position: 'right',
            color: PALETTE.axis,
            fontSize: 11,
            formatter: (p: { value?: unknown }) => Number(p.value ?? 0).toLocaleString(),
          },
        },
      ],
    }),
    [series],
  );

  return (
    <AnalyticsCard
      title="Languages"
      subtitle="Users by interface language"
      isLoading={isLoading}
      isFetching={isFetching}
      isEmpty={!isLoading && series.length === 0}
      emptyMessage="No data"
      chartHeight={300}
      chart={<EChart option={option} height={300} />}
    />
  );
};
